export default __webpack_public_path__ + "static/media/offsetting-expo.4945080d.png";